import { createFileRoute } from "@tanstack/react-router";
import {
  CustomIndustryServicePage,
  buildCustomIndustryServiceHead,
} from "@/components/CustomIndustryServicePage";
import { getCustomEntry } from "@/lib/customIndustryServiceData";

const ENTRY = getCustomEntry("seo-for-hvac")!;

export const Route = createFileRoute("/seo-for-hvac")({
  head: () => buildCustomIndustryServiceHead(ENTRY),
  component: () => <CustomIndustryServicePage entry={ENTRY} />,
});
